// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3Qqr0","col":"styles_col__3gWni"};